export default function headerSticky({main, elm, unmount}) {
	const delta = 10;
	let offset = elm.offsetHeight;
	let lastScroll = Math.max(window.scrollY, 0);
	let ticking = false;
	let animationFrame = null;
	let resizeObserver = null;
	let hidden = elm.classList.contains('header--hidden');

	main(_ => {
		init();

		window.addEventListener('scroll', onScroll, { passive: true });
	});

	unmount(() => {
		window.removeEventListener('scroll', onScroll);
		resizeObserver?.disconnect();

		if (animationFrame !== null) {
			cancelAnimationFrame(animationFrame);
		}
	});

	const init = function () {
		resizeObserver = new ResizeObserver(() => {
			offset = elm.offsetHeight;
		});

		resizeObserver.observe(elm);
	}

	const onScroll = function () {
		if (ticking) return;

		animationFrame = requestAnimationFrame(updateState);
		ticking = true;
	};

	const updateState = function () {
		animationFrame = null;
		ticking = false;

		const currentScroll = Math.max(window.scrollY, 0);
		const diff = currentScroll - lastScroll;

		if (currentScroll <= offset) {
			setHidden(false);
			lastScroll = currentScroll;
			return;
		}

		if (Math.abs(diff) < delta) {
			return;
		}

		setHidden(diff > 0);
		lastScroll = currentScroll;
	};

	const setHidden = function (nextHidden) {
		if (hidden === nextHidden) return;

		hidden = nextHidden;
		elm.classList.toggle('header--hidden', hidden);
		document.body.classList.toggle('header-hidden', hidden);
	};
};

export const model = {};
